import './birddogbbq/style';
import FormStructure from './birddogbbq/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js